import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {FusePageSimple, FuseAnimate} from '@fuse';

import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as Actions from 'store/actions';
import { Paper, Grid, Button, Divider, Typography, Dialog, DialogContent } from '@material-ui/core';
import ReplayIcon from '@material-ui/icons/Replay';

// import Dropzone from 'react-dropzone';
import 'react-dropzone-uploader/dist/styles.css';
import Dropzone from 'react-dropzone-uploader';

const styles = theme => ({
    layoutRoot: {},
    pagingPeringkat: {
        textAlign: 'right'
    }
});

class BackupRestore extends Component {
    state = {
        error:0,
        openDialog: false,
        openDialogBerhasil: false,
        fullWidth: true,
        maxWidth: 'sm',
        file_gambar_ktp: '',
        routeParams: {
            sekolah_id: JSON.parse(localStorage.getItem('user')).sekolah_id,
            pengguna_id: JSON.parse(localStorage.getItem('user')).pengguna_id,
        }
    }

    goTolink = (url) => {
        this.props.history.push(url);
    };

    componentDidMount = () => {
        this.props.setLoadingBesar(true);

        this.props.setJudul('Backup/Restore');

        this.setState({
            routeParams: {
                sekolah_id: JSON.parse(localStorage.getItem('user')).sekolah_id,
                pengguna_id: JSON.parse(localStorage.getItem('user')).pengguna_id,
            }
        },()=>{
            this.props.getLogBackup(this.state.routeParams).then((result)=>{
                this.props.setLoadingBesar(false);
            });
            
            this.props.getLogRestore(this.state.routeParams).then((result)=>{
                this.props.setLoadingBesar(false);
            });
        });
    }

    prosesBackup = () => {
        this.props.setLoadingBesar(true);

        this.setState({
            routeParams: {
                sekolah_id: JSON.parse(localStorage.getItem('user')).sekolah_id,
                pengguna_id: JSON.parse(localStorage.getItem('user')).pengguna_id
            }
        },()=>{
            this.props.backup(this.state.routeParams).then((result)=>{
                // console.log(this.props.data_backup.path);    

                // this.props.setLoadingBesar(false);

                window.open('http://'+window.location.hostname+':1746'+this.props.data_backup.path);

                this.props.getLogBackup(this.state.routeParams).then((result)=>{
                    this.props.setLoadingBesar(false);
                });

                // window.location.href=this.props.backup.path;
            })
        });
    }

    prosesRestore = () => {
        this.setState({
            ...this.state,
            openDialog: true
        });
    }

    acceptedFile = (file) => {
        if(file[0].size >= 50000000){ //50MB
            return true;
        }

        if(file[0].name.substr(file[0].name.length - 3) === 'odb'){

            

        }else{
            this.$f7.dialog.alert('Hanya dapat mengupload file berkas dengan format .odb!', 'Peringatan');
            return true;
        }
    }

    tutupRestore = () => {
        this.setState({
            ...this.state,
            openDialog: false
        });
    }

    // specify upload params and url for your files
    // getUploadParams = ({ meta }) => { 
    //     return { 
    //         url: 'http://'+window.location.hostname+':1746/api/upload?pengguna_id='+JSON.parse(localStorage.getItem('user')).pengguna_id+'&sekolah_id='+JSON.parse(localStorage.getItem('user')).sekolah_id
    //     } 
    // }
    getUploadParams = ({ file, meta }) => {
        const body = new FormData()
        body.append('file', file);
        body.append('sekolah_id', JSON.parse(localStorage.getItem('user')).sekolah_id);
        body.append('pengguna_id', JSON.parse(localStorage.getItem('user')).pengguna_id);
        // return { url: 'http://pmpoff:1746/api/upload?pengguna_id='+JSON.parse(localStorage.getItem('user')).pengguna_id+'&sekolah_id='+JSON.parse(localStorage.getItem('user')).sekolah_id, body }
        return { url: 'http://'+window.location.hostname+':1746/api/upload', body }
    }
    
    // called every time a file's `status` changes
    handleChangeStatus = ({ meta, file }, status) => { 
        // console.log(file);
        // this.state.routeParams.nama_file = file.name;
        this.setState({
            routeParams: {
                ...this.state.routeParams,
                nama_file: file.name
            }
        })

        // this.props.restore(this.state.routeParams).then((result)=>{

        // });

        // console.log(this.state);
        // this.setState({
        //     ...this.state,
        //     nama_file: file.name
        // },()=>{
        //     console.log(this.state);
        // });

    }
    
    // receives array of files that are done uploading when submit button is clicked
    handleSubmit = (files, allFiles) => {
        console.log(files.map(f => f.meta))
        allFiles.forEach(f => f.remove())
    }

    restore = () => {
        this.props.setLoadingBesar(true);
        this.props.restore(this.state.routeParams).then((result)=>{
            this.props.setLoadingBesar(false);

            this.setState({
                openDialog: false,
                openDialogBerhasil: true
            },()=>{
                this.props.getLogRestore(this.state.routeParams).then((result)=>{
                    this.props.setLoadingBesar(false);
                });
            });
        });
    }

    tutupRestoreBerhasil = () => {
        this.setState({
            openDialogBerhasil: false
        });
    }

    render()
    {
        const {classes} = this.props;
        
        return (
            <FusePageSimple
                classes={{
                    root: classes.layoutRoot
                }}
                content={
                    <FuseAnimate
                        animation="transition.slideRightBigIn"
                        duration={400}
                        delay={400}
                    >
                        <div style={{width: '100%', padding: 10}} className="konten-utama">
                        <Dialog
                                open={this.state.openDialogBerhasil}
                                fullWidth={this.state.fullWidth}
                                maxWidth={this.state.maxWidth}
                            >
                                <DialogContent id="loading-dialog" style={{textAlign: 'left'}}>
                                    <Typography variant="h1">Restore Berhasil!</Typography>
                                    <br/>
                                    <Divider/>
                                    <br/>
                                    <Button variant="raised" onClick={this.tutupRestoreBerhasil}>Selesai</Button>
                                </DialogContent>
                            </Dialog>
                            <Dialog
                                open={this.state.openDialog}
                                fullWidth={this.state.fullWidth}
                                maxWidth={this.state.maxWidth}
                            >
                                <DialogContent id="loading-dialog" style={{textAlign: 'left'}}>
                                    <Typography variant="h3">Pilih file backup yang akan direstore</Typography>
                                    <br/>
                                    Perhatian!
                                    <br/>
                                    <p>
                                        <ol>
                                            <li>
                                                Proses restore akan mengganti hasil pengisian yang telah ada di dalam aplikasi dengan hasil pengisian dari file backup yang diproses!
                                            </li>
                                            <li>
                                                <b>Proses restore ini tidak dapat dibatalkan.</b> Pastikan Anda yakin untuk melakukan proses ini!
                                            </li>
                                        </ol>
                                    </p>
                                    <br/>
                                    <Divider/>
                                    <br/>
                                    <Dropzone
                                        getUploadParams={this.getUploadParams}
                                        onChangeStatus={this.handleChangeStatus}
                                        onSubmit={this.handleSubmit}
                                        multiple={false}
                                        submitButtonDisabled={true}
                                        submitButtonContent={null}
                                        inputWithFilesContent={null}
                                        // InputComponent={null}
                                        SubmitButtonComponent={null}
                                        maxFiles={1}
                                        inputContent="Tarik dan seret berkas backup Anda ke sini, atau klik/Sentuh untuk cari berkas backup di komputer Anda"
                                        // accept="application/vnd.oasis.opendocument.database"
                                        styles={{ dropzone: { minHeight: 200, maxHeight: 250, border:'4px dashed #ccc', padding:'10px', textAlign:'center' } }}
                                    />
                                    {/* <Dropzone className="droping" onDrop={this.acceptedFile}>
                                    {({getRootProps, getInputProps}) => (
                                        <section>
                                            <div {...getRootProps()} style={{height:'250px',border:'4px dashed #ccc', textAlign: 'center', paddingTop:(this.state.file_gambar_ktp !== '' ? '16px' : '10%'), paddingLeft:'16px', paddingRight:'16px'}}>
                                                <input {...getInputProps()} />
                                                {this.state.file_gambar_ktp === '' &&
                                                <i slot="media" className="f7-icons" style={{fontSize:'60px', color:'#434343'}}>square_arrow_up</i>
                                                }
                                                {this.state.file_gambar_ktp !== '' &&
                                                <div>
                                                    <img style={{height:'150px'}} src={localStorage.getItem('api_base')+this.state.file_gambar_ktp} />
                                                    <p style={{fontSize:'12px', fontStyle:'italic'}}>Klik/Sentuh kembali untuk mengganti berkas</p>
                                                </div>
                                                }
                                                {this.state.gambar_ktp === '' &&
                                                <div>
                                                    <p>Tarik dan seret berkas backup Anda ke sini, atau klik/Sentuh untuk cari berkas backup di komputer Anda</p>
                                                </div>
                                                }
                                                {this.state.gambar_ktp !== '' && this.state.file_gambar_ktp === '' &&
                                                <div>
                                                    <p style={{fontSize:'20px'}}>{this.state.gambar_ktp}</p>
                                                    <p style={{fontSize:'12px', fontStyle:'italic'}}>Klik/Sentuh kembali untuk mengganti berkas</p>
                                                </div>
                                                }
                                            </div>
                                        </section>
                                    )}
                                    </Dropzone> */}
                                    <br/>
                                    <Divider/>
                                    <br/>
                                    <Button color="primary" variant="raised" onClick={this.restore}>Restore</Button>
                                    &nbsp;
                                    <Button variant="raised" onClick={this.tutupRestore}>Batal</Button>
                                </DialogContent>
                            </Dialog>
                            {/* <GhostList/>
                            <GhostList/>
                            <GhostList/>
                            <GhostList/> */}

                            <Paper className="p-16" style={{textAlign:'center'}}>
                                <Button size="large" variant="contained" color="secondary" onClick={this.prosesBackup}>
                                    <ReplayIcon /> &nbsp; Backup
                                </Button>
                                {/* &nbsp; */}
                                {/* <Button size="large" variant="contained" color="secondary" onClick={this.prosesRestore} disabled>
                                    <CompareIcon /> &nbsp; Restore
                                </Button>
                                *Rest */}
                                <br/>
                                <i>* Hanya digunakan dalam kondisi darurat</i>
                            </Paper>
                            <Paper className="p-16">
                                <h1>Riwayat Backup</h1>
                                <br/>
                                <Grid container>
                                    <Grid item sm={3}>
                                        <b>Tanggal</b>
                                    </Grid>
                                    <Grid item sm={4}>
                                        <b>Keterangan</b>
                                    </Grid>
                                    <Grid item sm={5}>
                                        <b>Pengguna</b>
                                    </Grid>
                                </Grid>
                                <Divider/>
                                {this.props.log_backup.rows.map((option)=>{
                                    return(
                                        <Grid container style={{marginBottom:'4px'}}>
                                            <Grid item sm={3} style={{fontFamily:'Consolas, Menlo, Monaco, Lucida Console, Liberation Mono, DejaVu Sans Mono, Bitstream Vera Sans Mono, Courier New, monospace, serif'}}>
                                                {option.waktu_mulai}
                                                <Divider/>
                                            </Grid>
                                            <Grid item sm={4} style={{fontFamily:'Consolas, Menlo, Monaco, Lucida Console, Liberation Mono, DejaVu Sans Mono, Bitstream Vera Sans Mono, Courier New, monospace, serif'}}>
                                                {option.keterangan}
                                                <Divider/>
                                            </Grid>
                                            <Grid item sm={5} style={{fontFamily:'Consolas, Menlo, Monaco, Lucida Console, Liberation Mono, DejaVu Sans Mono, Bitstream Vera Sans Mono, Courier New, monospace, serif'}}>
                                                {option.nama_pengguna} - {option.peran}
                                                <Divider/>
                                            </Grid>

                                        </Grid>
                                    )
                                })}
                            </Paper>
                            {/* <Paper className="p-16">
                                <h1>Riwayat Restore</h1>
                                <br/>
                                <Grid container>
                                    <Grid item sm={3}>
                                        <b>Tanggal</b>
                                    </Grid>
                                    <Grid item sm={4}>
                                        <b>Keterangan</b>
                                    </Grid>
                                    <Grid item sm={5}>
                                        <b>Pengguna</b>
                                    </Grid>
                                </Grid>
                                <Divider/>
                                {this.props.log_restore.rows.map((option)=>{
                                    return(
                                        <Grid container style={{marginBottom:'4px'}}>
                                            <Grid item sm={3} style={{fontFamily:'Consolas, Menlo, Monaco, Lucida Console, Liberation Mono, DejaVu Sans Mono, Bitstream Vera Sans Mono, Courier New, monospace, serif'}}>
                                                {option.waktu_mulai}
                                                <Divider/>
                                            </Grid>
                                            <Grid item sm={4} style={{fontFamily:'Consolas, Menlo, Monaco, Lucida Console, Liberation Mono, DejaVu Sans Mono, Bitstream Vera Sans Mono, Courier New, monospace, serif'}}>
                                                {option.keterangan}
                                                <Divider/>
                                            </Grid>
                                            <Grid item sm={5} style={{fontFamily:'Consolas, Menlo, Monaco, Lucida Console, Liberation Mono, DejaVu Sans Mono, Bitstream Vera Sans Mono, Courier New, monospace, serif'}}>
                                                {option.nama_pengguna} - {option.peran}
                                                <Divider/>
                                            </Grid>

                                        </Grid>
                                    )
                                })}
                            </Paper> */}
                        </div>
                    </FuseAnimate>
                }
            />
        )
    }

}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getSekolah: Actions.getSekolah,
        setKunciKonfirmasiInstrumen: Actions.setKunciKonfirmasiInstrumen,
        getKonfirmasiSelesai: Actions.getKonfirmasiSelesai,
        getKemajuanTotal: Actions.getKemajuanTotal,
        getPeringkatPengisian: Actions.getPeringkatPengisian,
        setLoading: Actions.setLoading,
        setLoadingBesar: Actions.setLoadingBesar,
        setJudul: Actions.setJudul,
        backup: Actions.backup,
        restore: Actions.restore,
        getLogBackup: Actions.getLogBackup,
        getLogRestore: Actions.getLogRestore,
    }, dispatch);
}

function mapStateToProps({ Sekolah, Instrumen, App }) {

    return {
        sekolah: Sekolah.sekolah,
        konfirmasi_instrumen_id: Instrumen.konfirmasi_instrumen_id,
        konfirmasi_instrumen: Instrumen.konfirmasi_instrumen,
        kemajuan_total: Instrumen.kemajuan_total,
        peringkat_pengisian: Instrumen.peringkat_pengisian,
        judul: App.judul,
        data_backup: App.backup,
        log_backup: App.log_backup,
        log_restore: App.log_restore
    }
}

// export default withStyles(styles, {withTheme: true})(Beranda);
export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(BackupRestore)));



// WEBPACK FOOTER //
// ./src/main/content/Pengaturan/BackupRestore.js